import { Module } from '@nestjs/common';
import { AuditModule } from 'src/audit/audit.module';
import { ContabilidadModule } from 'src/contabilidad/contabilidad.module';
import { PrismaModule } from 'src/prisma/prisma.module';
import { GastosController } from './gastos.controller';
import { GastosService } from './gastos.service';
import { GastosTesoreriaService } from './services/gastos-tesoreria.service';
import { ImportacionesModule } from '../importaciones/importaciones.module';

@Module({
  imports: [PrismaModule, ContabilidadModule, AuditModule, ImportacionesModule],
  controllers: [GastosController],
  providers: [GastosService, GastosTesoreriaService],
  exports: [GastosService],
})
export class GastosModule {}
